import React, {useState, useEffect, useRef} from 'react';
import {Formik} from 'formik';
import Form from "react-bootstrap/Form"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {ajaxUrl, formUrl} from "../main";
import {FilePond, registerPlugin} from 'react-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

registerPlugin(FilePondPluginFileValidateType);
import 'filepond/dist/filepond.min.css'


const formPost = (endpoint, values, files) => {
    let formData = new FormData();

    for (let value in values) {
        formData.append(value, values[value]);
    }

    formData.append("returnUrl", formUrl)

    for (let i = 0; i < files.length; i++) {
        formData.append('file[]', files[i].file);
    }

    return fetch(endpoint, {
        method: 'POST',
        mode: 'same-origin',
        body: formData,
    });
};

const OrderForm = (props) => {
    const formRef = useRef()
    const [files, setFiles] = useState([])
    const [wordCountInput, setWordCountInput] = useState(0)
    const [wordCountFiles, setWordCountFiles] = useState(0)
    const [wordCountTotal, setWordCountTotal] = useState(0)
    const [valid, setValid] = useState(false)
    const [triedSubmitting, setTriedSubmitting] = useState(false)
    const [price, setPrice] = useState(0)
    const [isPriceQuery, setIsPriceQuery] = useState(false)
    const [priceQueryMsg, setPriceQueryMsg] = useState([])
    const [timeEstimate, setTimeEstimate] = useState(null)
    const [formOpt, setFormOptions] = useState({
        ready: 0,
        editingLanguages: {},
        languagePairs: {},
        maxWords: 0,
        minPrices: {
            editing: 0.0,
            translation: 0.0,
        },
        str: {
            lang: {},
            selectService: "Select service",
            serviceTranslation: "Translation",
            serviceEditing: "Editing",
            translateFrom: "From",
            translateTo: "To",
            email: "Email",
            submit: "Submit",
            selectLang: "Select language",
            enterContent: "Content",
            usedWords: "Used %s words",
            enterFiles: "Add files",
            fileUpload: 'Drag & Drop your files or <span class="filepond--label-action">Browse</span>',
            priceUnit: ' €',
            comments: "Extra comments",
            commentsPlaceholder: "Give extra comments about the order",
            contentPlaceholder: "Copy the text to be translated or edited",
            submitPriceQuery: "Submit price query",
            emailPlaceholder: "Enter email",
            phone: "Phone",
            phonePlaceholder: "Enter phone number",
            name: "Name/Company",
            contentTerms: ""
        }
    })

    useEffect(() => {
        fetch(ajaxUrl + '/order_form_options')
            .then(response => response.json())
            .then(response => response.data)
            .then(setFormOptions)
    }, [])

    useEffect(() => {
        setIsPriceQuery(!!Object.keys(priceQueryMsg).length)
    }, [priceQueryMsg])

    const setPrice2Decimal = (number) => {
        setPrice(Math.round(number * 100) / 100)
    }

    const calculatePrice = () => {
        setTimeout(() => {
            if (typeof formRef.current === "undefined" || typeof formRef.current.values === "undefined") {
                setPrice(0)
                return
            }

            const v = formRef.current.values

            if (!wordCountTotal || typeof v.service === "undefined") {
                setPrice(0)
                return
            }

            if (
                v.service === "1"
                && typeof formOpt.editingLanguages[v.editLang] !== "undefined"
            ) {
                let price = formOpt.editingLanguages[v.editLang] * wordCountTotal
                if (price < formOpt.minPrices.editing) {
                    price = formOpt.minPrices.editing
                }
                setPrice2Decimal(price);
            } else if (
                v.service === "2"
                && typeof formOpt.languagePairs[v.from] !== "undefined"
                && typeof formOpt.languagePairs[v.from][v.to] !== "undefined"
            ) {
                let price = formOpt.languagePairs[v.from][v.to] * wordCountTotal
                if (price < formOpt.minPrices.translation) {
                    price = formOpt.minPrices.translation
                }
                setPrice2Decimal(price)
            } else {
                setPrice(0)
            }
        }, 20)
    }

    useEffect(calculatePrice, [wordCountTotal])

    const validate = values => formPost(ajaxUrl + '/order_form_validate', values, files)
        .then(response => response.json())
        .then(response => response.data)
        .then(response => {
            setWordCountInput(response.wordCounts.inputs)
            setWordCountFiles(response.wordCounts.files)
            setWordCountTotal(response.wordCounts.total)
            setTimeEstimate(response.timeEstimate)
            setPriceQueryMsg(response.priceQuery)
            setValid(response.valid)
            return response.errors
        })

    return (<Formik
        innerRef={formRef}
        initialValues={{}}
        validate={validate}
        onSubmit={(values, {setSubmitting}) => {
            formPost(ajaxUrl + '/order_form_submit', values, files)
                .then(res => res.json())
                .then(res => {
                    // setSubmitting(false);
                    setTriedSubmitting(true);

                    if (!res.success) {
                        return
                    }

                    if (res.data.needsPayment) {
                        // if (typeof props.onNeedsPayment === "function") {
                        //     props.onNeedsPayment(res.data.orderPostId)
                        // }
                        if (res.data.paymentUrl) {
                            window.open(res.data.paymentUrl, '_blank').focus()
                        }
                    } else if (typeof props.onSentPriceQuery === "function") {
                        props.onSentPriceQuery(res.data.orderPostId)
                    }
                })
        }}
    >
        {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, validateForm}) => (
            <form
                onSubmit={handleSubmit}
                style={{
                    transition: "opacity .3s",
                    opacity: formOpt.ready ? "1" : ".2",
                }}
            >
                <div className="w-max">
                    <div className="container-fluid bg-secondary" style={{
                        padding: "3rem 0",
                        margin: "3rem auto",
                    }}>
                        <div className="container">
                            <Row className="row-grid">

                                <Col xs={12}>
                                    <Form.Group controlId="service">
                                        <Form.Label>{formOpt.str.selectService} <span
                                            className={"required"}>*</span></Form.Label>
                                        <Form.Select
                                            className="form-control"
                                            aria-label="Teenuse tüüp"
                                            value={values.service}
                                            onChange={e => {
                                                handleChange(e)
                                                calculatePrice()
                                            }}
                                        >
                                            <option>{formOpt.str.selectService}</option>
                                            <option value="1">{formOpt.str.serviceEditing}</option>
                                            <option value="2">{formOpt.str.serviceTranslation}</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                {values.service === "1" && <Col xs={12}>
                                    <Form.Group controlId="editLang">
                                        <Form.Label>{formOpt.str.selectLang} <span
                                            className={"required"}>*</span></Form.Label>
                                        <Form.Select
                                            className="form-control"
                                            aria-label={formOpt.str.translateFrom}
                                            value={values.editLang}
                                            onChange={e => {
                                                handleChange(e)
                                                calculatePrice()
                                            }}
                                        >
                                            <option>{formOpt.str.selectLang}</option>
                                            {Object.keys(formOpt.editingLanguages).map((key, i) => (
                                                <option key={key + i.toString()} value={key}>{formOpt.str.lang[key]}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>}

                                {values.service === "2" && <>
                                    <Col xs={6}>
                                        <Form.Group controlId="from">
                                            <Form.Label>{formOpt.str.translateFrom} <span
                                                className={"required"}>*</span></Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                aria-label={formOpt.str.translateFrom}
                                                value={values.from}
                                                onChange={e => {
                                                    handleChange(e)
                                                    calculatePrice()
                                                }}
                                            >
                                                <option>{formOpt.str.selectLang}</option>
                                                {[...new Set(Object.keys(formOpt.languagePairs))].map((key, i) => (
                                                    <option key={key + i.toString()} value={key}>{formOpt.str.lang[key]}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group controlId="to">
                                            <Form.Label>{formOpt.str.translateTo} <span
                                                className={"required"}>*</span></Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                aria-label={formOpt.str.translateTo}
                                                disabled={!values.from}
                                                value={values.to}
                                                onChange={e => {
                                                    handleChange(e)
                                                    calculatePrice()
                                                }}
                                            >
                                                <option>{formOpt.str.selectLang}</option>
                                                {Object.keys(formOpt.languagePairs[values.from] || {}).map((key, idx) => (
                                                    <option key={key + idx.toString()} value={key}>
                                                        {formOpt.str.lang[key]}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {errors.language && triedSubmitting &&
                                        <Col xs={12}><Form.Control.Feedback type="invalid" style={{display: "block"}}>
                                            {errors.language}
                                        </Form.Control.Feedback></Col>}
                                </>}

                                <Col xs={6}>
                                    <Form.Group controlId="content">
                                        <Form.Label>{formOpt.str.enterContent}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            style={{maxHeight: "none"}}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.content}
                                            placeholder={formOpt.str.contentPlaceholder}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs={6}>
                                    <Form.Group controlId="files">
                                        <Form.Label>{formOpt.str.enterFiles}</Form.Label>
                                        <FilePond
											allowMultiple={true}
											files={files}
											onupdatefiles={(...f) => {
												setFiles(...f);
												setTimeout(() => {
													validateForm();
												}, 100);
											}}
											maxFiles={3000}
											instantUpload={false}
											name="files"
											labelIdle={formOpt.str.fileUpload}
											inputAttributes={{ id: "files" }}
										/>
                                    </Form.Group>
                                </Col>

                                {errors.file &&
                                    <Col xs={12} md={{span: 8, offset: 2}}>
                                        <Form.Control.Feedback type="invalid" style={{
                                            display: "block",
                                            fontSize: '18px',
                                            lineHeight: '1.5',
                                            fontWeight: '700',
                                            textAlign: 'center'
                                        }}>
                                            {errors.file}
                                        </Form.Control.Feedback>
                                    </Col>
                                }

                                {(!errors.file && isPriceQuery) && (Object.keys(priceQueryMsg).map((key) => (
                                    <Col xs={12} md={{span: 8, offset: 2}}>
                                        <Form.Control.Feedback type="invalid" style={{
                                            color: 'var(--wp--preset--color--orange)',
                                            display: 'block',
                                            fontSize: '18px',
                                            lineHeight: '1.5',
                                            fontWeight: '700',
                                            textAlign: 'center'
                                        }} key={key}>
                                            {priceQueryMsg[key]}
                                        </Form.Control.Feedback>
                                    </Col>
                                )))}

                                <Col xs={12}>
                                    {(!errors.file && !isPriceQuery) && <Form.Text>
                                        {formOpt.str.usedWords.replace("%s", (wordCountFiles + wordCountInput) + " / " + formOpt.maxWords)}
                                    </Form.Text>}
                                </Col>

                                {
                                    !isPriceQuery
                                    && !!price
                                    && <Col xs={12}>
                                        <h2 style={{textAlign: "center"}}>
                                            {price}{formOpt.str.priceUnit}
                                        </h2>
                                        {!!timeEstimate &&
                                            <h4 style={{textAlign: "center", marginTop: "20px"}}>
                                                {timeEstimate}
                                            </h4>
                                        }
                                    </Col>
                                }
                            </Row>
                        </div>
                    </div>
                </div>

                <Row className="row-grid">

                    <Col xs={12}>
                        <Form.Group controlId="comments">
                            <Form.Label>{formOpt.str.comments}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                style={{maxHeight: "none"}}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.comments}
                                placeholder={formOpt.str.commentsPlaceholder}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group controlId="email">
                            <Form.Label>{formOpt.str.email} <span className={"required"}>*</span></Form.Label>
                            <Form.Control
                                type="email"
                                placeholder={formOpt.str.emailPlaceholder}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email || ""}
                            />
                            {errors.email && touched.email &&
                                <Form.Control.Feedback type="invalid" style={{display: "block"}}>
                                    {errors.email}
                                </Form.Control.Feedback>}
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group controlId="name">
                            <Form.Label>{formOpt.str.name} <span className={"required"}>*</span></Form.Label>
                            <Form.Control
                                type="name"
                                placeholder={formOpt.str.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name || ""}
                            />
                            {errors.name && touched.name &&
                                <Form.Control.Feedback type="invalid" style={{display: "block"}}>
                                    {errors.name}
                                </Form.Control.Feedback>}
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group controlId="phone">
                            <Form.Label>{formOpt.str.phone}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={formOpt.str.phonePlaceholder}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.phone || ""}
                            />
                        </Form.Group>
                    </Col>

                    {!!formOpt.str.contentTerms && <Col
                        xs={12}
                        style={{
                            fontSize: '90%',
                            paddingTop: '15px',
                            paddingBottom: '15px'
                        }}
                        dangerouslySetInnerHTML={{
                            __html: formOpt.str.contentTerms
                        }}
                    />}

                    <Col xs={12}>
                        <button type="submit" className="btn" disabled={isSubmitting || !valid}>
                            {isPriceQuery ? formOpt.str.submitPriceQuery : formOpt.str.submit}
                        </button>
                    </Col>
                </Row>
            </form>)
        }
    </Formik>)
}

export default OrderForm;
